import { render, staticRenderFns } from "./AddSupplementalMessage.vue?vue&type=template&id=a374bdba&scoped=true&"
import script from "./AddSupplementalMessage.vue?vue&type=script&lang=js&"
export * from "./AddSupplementalMessage.vue?vue&type=script&lang=js&"
import style0 from "./AddSupplementalMessage.vue?vue&type=style&index=0&id=a374bdba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a374bdba",
  null
  
)

export default component.exports